import { Routes, Route } from "react-router-dom";
import { AppointmentProvider } from "./context/AppointmentContext";
import { useAppointment } from "./context/AppointmentContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import BiomedicalWaste from "./pages/BiomedicalWaste"
import Home from "./pages/Home";
import "../src/styles/globals.css";
import About from "./pages/About";
import Departments from "./pages/Departments";
import HealthPackages from "./components/HealthPackages";
import Doctors from "./pages/Doctors";
import Gallery from "./components/Gallery";
import Contact from "./pages/Contact";
import BookAppointment from "../src/pages/BookAppointment";
import News from "./pages/News";
import NewsPost from "./pages/NewsPost";
import DoctorDetail from "./pages/DoctorDetail";
import CardiologyPage from "./components/Cardiology";
import ENTPage from "./components/ENT";
import NeurologyPage from "./components/Neurology";
import PlasticSurgeryPage from "./components/PlasticSurgery";
import UrologyPage from "./components/Urology";
import NephrologyPage  from "./components/Nephrology";
import EndocrinologyPage from "./components/Endocrinology";
import PediatricSurgeryPage from "./components/PediatricSurgery";
import GastroenterologyPage from "./components/Gastroenterology";
import NeurosurgeryPage from "./components/Neurosurgery";
import GeneralMedicinePage from "./components/GeneralMedicine";
import GeneralSurgeryPage from "./components/GeneralSurgery";
import OrthopaedicsPage from "./components/Orthopaedics";
import ObstetricsGynaecologyPage from "./components/ObstetricsGynaecology";
import PaediatricsPage from "./components/Paediatrics";
import DermatologyPage from "./components/Dermatology";
import OpthalmologyPage from "./components/Ophthalmology";
import RadiologyPage from "./components/Radiology";
import PsychiatryPage from "./components/Psychiatry";
import EmergencyTraumaPage from "./components/EmergencyTrauma";
import PainMedicinePage from "./components/PainMedicine";
import SportsMedicinePage from "./components/SportsMedicine";
import CriticalCarePage from "./components/CriticalCare";
import AnaesthesiologyPage from "./components/Anaesthesiology";
import DentalPage from "./components/Dental";
import PhysiotherapyPage from "./components/Physiotherapy";
import LeanLifePage from "./components/LeanLife";
import ENTLandingPage from "./pages/ENTLandingPage";
import HospitalsLandingPage from "./pages/HospitalLandingPage";
import PulmonologyPage from "./components/Pulmonology";
import Blogs from "./pages/Blogs";
import BlogDetail from "./pages/BlogDetail";

import "./index.css";

import "./index.css";

function AppInner() {
  const { isOpen, close } = useAppointment();
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <ScrollToTop />
      <BookAppointment isOpen={isOpen} onClose={close} />
      <main className="flex-1">
        <Routes>

          <Route path="/" element={<Home />} />
          <Route path="/biomedicalwaste" element={<BiomedicalWaste />} />
          <Route path="/about" element={<About />} />
          <Route path="/departments" element={<Departments />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/health-packages" element={<HealthPackages />} />
          <Route path="/doctors" element={<Doctors />} />
          <Route path="/doctors/:slug" element={<DoctorDetail />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/book-appointment" element={<BookAppointment />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:slug" element={<NewsPost />} />
          <Route path="/departments/cardiology" element={<CardiologyPage />} />
          <Route path="/departments/ent" element={<ENTPage />} />
          <Route path="/departments/neurology" element={<NeurologyPage />} />
          <Route path="/departments/plasticsurgery" element={<PlasticSurgeryPage />} />
          <Route path="/departments/urology" element={<UrologyPage />} />
          <Route path="/departments/nephrology" element={<NephrologyPage />} />
          <Route path="/departments/endocrinology" element={<EndocrinologyPage />} />
          <Route path="/departments/pediatric-surgery" element={<PediatricSurgeryPage />} />
          <Route path="/departments/gastroenterology" element={<GastroenterologyPage />} />
          <Route path="/departments/neurosurgery" element={<NeurosurgeryPage />} />
          <Route path="/departments/general-medicine" element={<GeneralMedicinePage />} />
          <Route path="/departments/general-surgery" element={<GeneralSurgeryPage />} />
          <Route path="/departments/orthopaedics" element={<OrthopaedicsPage />} />
          <Route path="/departments/obstetrics-gynaecology" element={<ObstetricsGynaecologyPage />} />
          <Route path="/departments/paediatrics" element={<PaediatricsPage />} />
          <Route path="/departments/dermatology" element={<DermatologyPage />} />
          <Route path="/departments/ophthalmology" element={<OpthalmologyPage />} />
          <Route path="/departments/radiology" element={<RadiologyPage />} />
          <Route path="/departments/psychiatry" element={<PsychiatryPage />} />
          <Route path="/departments/emergency-trauma" element={<EmergencyTraumaPage />} />
          <Route path="/departments/pain-medicine" element={<PainMedicinePage />} />
          <Route path="/departments/sports-medicine" element={<SportsMedicinePage />} />
          <Route path="/departments/critical-care" element={<CriticalCarePage />} />
          <Route path="/departments/anaesthesiology" element={<AnaesthesiologyPage />} />
          <Route path="/departments/dental" element={<DentalPage />} />
          <Route path="/departments/physiotherapy" element={<PhysiotherapyPage />} />
          <Route path="/departments/leanlife" element={<LeanLifePage />} />
          <Route path="/ent-hospital-hyderabad" element={<ENTLandingPage />}/>
          <Route path="/best-hospital-in-hyderabad" element={<HospitalsLandingPage />}/>
          <Route path="/departments/pulmonology" element={<PulmonologyPage />} />
          <Route path="/blog" element={<Blogs />} />
          <Route path="/blog/:slug" element={<BlogDetail />} /><Route path="/blog" element={<Blogs />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          

        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <AppointmentProvider>
      <AppInner />
    </AppointmentProvider>
  );
}

export default App;
